
import { Injectable } from '@angular/core';
import { HeaderService } from '../header.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import RoutesserviceService from '../routesservice.service';

@Injectable({
  providedIn: 'root',
})
export class AttendanceService {
  public showSpinner = true;
  constructor(
    private httpClient: HttpClient,
    private Customeroutes: RoutesserviceService,
    private HeaderService: HeaderService
  ) { }

  async attendanceCorrection(
    _user_id: any,
    _attendance_id: any,
    _check_in: any,
    _check_out: any,
    _working_hours: any,
    _overtime: any,
    _type: any,
    _date: any,
    _reason: any,
    _status: any,
    old_value: any
  ) {

    const formData = {
      user_id: _user_id,
      attendance_id: _attendance_id,
      check_in: _check_in,
      check_out: _check_out,
      working_hours: _working_hours,
      overtime: _overtime,
      type: _type,
      date: _date,
      reason: _reason,
      status: _status,
      old_value: old_value,


    };
    const httpFormDataOptions = new HttpHeaders();
    return this.httpClient
      .post(this.Customeroutes.attendanceCorrection(), formData, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {

          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }

  async getAttendanceReqData(attendance_id: any) {
    const postBody = {
      attendance_id: attendance_id,
    };
    return this.httpClient
      .post(this.Customeroutes.getAttendance(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
      });
  }


  async getAttendance(_startdate: any,
    _enddate: any,
    _month: any,
    _attendance_tyoe: any) {
    const postBody = {
      start_date: _startdate || '',
      end_date: _enddate || ''
    };
    return this.httpClient
      .post(this.Customeroutes.getAttendance(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
      });
  }


  async getUserttendance(id: any) {
    const postBody = {
      id: id
    };

    return this.httpClient
      .post(this.Customeroutes.getUserAttendance(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
      });
  }




  async getAttendanceFilter(
    _startdate: any,
    _enddate: any,
    _month: any,
    _attendance_tyoe: any
  ) {
    const postBody = {
      start_date: _startdate || '',
      end_date: _enddate || '',
      month: _month || null,
      attendance_type: _attendance_tyoe || null,
    };
    return this.httpClient
      .post(this.Customeroutes.getAttendanceFilters(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }

  async getStatsFilter() {

    return this.httpClient
      .post(this.Customeroutes.getAttendanceStats(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }


  async getrequest() {
    return this.httpClient
      .get(this.Customeroutes.getAttndancerequest(), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });

  }



  async getAttendancefilter(_name: any, _start_date: any, _end_date: any , attendanceid: any, type:any ,department:any,sort_by:any ) {
    const postFilter = {
      name: _name || '',
      start_date: _start_date || '',
      end_date: _end_date || '',
      attendance_id: attendanceid || '',
      sort_type: type || '',
      department: department || '',
      sort_by: sort_by || ''
    };
    return this.httpClient
      .post(this.Customeroutes.getFilterAttedance(), postFilter, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }


  async routefilter(routfilter: any) {
    const postFilter = {
      type: routfilter,
    };
    return this.httpClient
      .post(this.Customeroutes.getFilterAttedance(), postFilter, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }


  async getattendancerequest(id: any) {
    const postFilter = {
      attendance_id: id,
    };
    return this.httpClient
      .post(this.Customeroutes.getAttendanceRequestData(), postFilter, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }

  async deleteAttendance(id: any) {
    const postBody = {
      id: id,
    };
    return this.httpClient
      .post(this.Customeroutes.deleteAttendance(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

}

